// extracted by mini-css-extract-plugin
export default {"campaign-button":"Campaign_campaign-button__WzzDJ"};